import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const downloadCampaignPdf = async (token, campaignId, lang, companyName) => {
  const res = await axios.get(`${API}/admin/campaigns/${campaignId}/report`, {
    params: { lang },
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^";]+)"?/);
  const slug = (companyName || "report").replace(/[^A-Za-z0-9]+/g, "-").replace(/^-|-$/g, "");
  const filename = match ? match[1] : `ECLENIA-Report-${slug}.pdf`;
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
